import { CodeMetadataWire, CodetableMetadata } from 'app/area/codetable/types-store';

export const mapMetadataToStore = (metadataWire: CodeMetadataWire): CodetableMetadata => ({
  ...(!!metadataWire.label && {
    label: metadataWire.label
  }),

  ...(!!metadataWire.formName && {
    formName: metadataWire.formName
  }),

  ...(!!metadataWire.code && {
    codetable: metadataWire.code
  }),

  ...(!!metadataWire.category && {
    codetableCategory: metadataWire.category
  }),

  ...(!!metadataWire.class && {
    codetableClass: metadataWire.class
  }),

  ...(!!metadataWire.node && {
    codetableNode: metadataWire.node
  }),

  ...(!!metadataWire.colourCode && {
    colourCode: metadataWire.colourCode
  }),

  ...(!!metadataWire.companyRegisterId && {
    companyRegisterId: metadataWire.companyRegisterId
  }),

  ...(!!metadataWire.merge && {
    merge: !!metadataWire.merge
  }),

  features: {
    ...(!!metadataWire.language && metadataWire.language.description && {
      description: !!metadataWire.language.description
    }),

    ...(!!metadataWire.language && metadataWire.language.longDescription && {
      longDescription: !!metadataWire.language.longDescription
    }),

    ...(!!metadataWire.application && {
      caseType: !!metadataWire.application
    }),

    ...(!!metadataWire.subset && {
      userGroup: !!metadataWire.subset
    }),

    ...(!!metadataWire.exclude && {
      visible: !!metadataWire.exclude
    }),

    ...(!!metadataWire.hierarchy && {
      hierarchy: metadataWire.hierarchy
    }),

    ...(!!metadataWire.disabled && {
      disabled: metadataWire.disabled
    }),

    ...(!!metadataWire.sequence && {
      sequence: !!metadataWire.sequence
    }),

    ...(!!metadataWire.icon && {
      icon: !!metadataWire.icon
    }),

    ...(!!metadataWire.decimalColour && {
      colour: !!metadataWire.decimalColour
    })
  }
});
